import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Slide } from '../../Type/okeeycash-slide.interface';

@Component({
  selector: 'slide-content',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterModule],
  templateUrl: './slide-content.component.html',
  styleUrl: './slide-content.component.scss'
})
export class SlideContentComponent {
  @Input() public slide: Slide;
  @Input() public $index: number;
  @Input() public routerUrl: string;
  @Input() public isLastTutorialSlide: boolean;
  @Input() public JourneyRoute: boolean;
  constructor(
    public _router: Router,
    private route: ActivatedRoute
  ) {}

  public doesUrlInclude(routeSegment: string): boolean {
    return this._router.url.includes(routeSegment);
  }

  public openLink(link: string): void {
    if (link.startsWith('http')) {
      window.open(link, '_blank');
    } else {
      this._router.navigate([link], { relativeTo: this.route.parent });
    }
  }
}
